// material
import ModernTable from '../components/ModernTable';
import { useTheme } from '@mui/material/styles';
import { CloudDownload } from '@mui/icons-material';
import { Email } from '@mui/icons-material';
import request from '../../../services/Request';
import Swal from 'sweetalert2';
import { Typography, Box, Chip, alpha } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import { fShortenNumber } from './utils/formatNumber';
import { fCurrency } from './utils/formatNumber';
import { useEffect } from 'react';
import moment from 'moment';
import { ExportToCsv } from 'export-to-csv';
import ComputerIcon from '@mui/icons-material/Computer';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ReceiptIcon from '@mui/icons-material/Receipt';

export default function MaSaleTable(props) {
  const theme = useTheme();
  const { endDate, startDate, mcSale, machinesName } = props;

  const MyNewTitle = ({ text = 'Table Title', variant = 'h6' }) => (
    <Typography
      variant={variant}
      style={{ overflow: 'hidden', textOverflow: 'ellipsis', marginTop: '20px' }}
    >
      {`Machine Sales Table (${machinesName} from ${startDate.toShortFormat()} to  ${endDate.toShortFormat()})`}
    </Typography>
  );

  const msSaleTable = () => {
    const newArray = mcSale.map((item) => {
      return {
        Id: item.machineName,
        Description: item.machineDescription,
        'Total Sale': item.totalSale,
        'Total Tax': item.totalTax,
        'Total Cost Price': item.costTotal,
        'Total Profit': parseFloat((item.totalSale - item.costTotal).toFixed(2)),
        'Total Transaction': item.totalTrans,
      };
    });

    // console.log(newArray);

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      useTextFile: false,
      filename: 'Machine Sales Report',
      useKeysAsHeaders: true,
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(newArray);
  };

  const columns = [
    {
      title: 'Machine ID',
      field: 'machineName',
      render: (rowData) => (
        <Chip
          label={rowData.machineName}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Description',
      field: 'machineDescription',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
          {rowData.machineDescription}
        </Typography>
      ),
    },
    {
      title: 'Total Sale',
      field: 'totalSale',
      render: (rowData) => (
        <Chip
          label={fCurrency(rowData.totalSale)}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Total Tax',
      field: 'totalTax',
      render: (rowData) => (
        <Chip
          label={fCurrency(rowData.totalTax)}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Total Cost Price',
      field: 'costTotal',
      render: (rowData) => (
        <Chip
          label={fCurrency(rowData.costTotal)}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.error.main, 0.12),
            color: theme.palette.error.dark,
            border: `1.5px solid ${alpha(theme.palette.error.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Total Profit',
      render: (rowData) => (
        <Chip
          icon={<TrendingUpIcon sx={{ fontSize: 16 }} />}
          label={fCurrency(rowData.totalSale - rowData.costTotal)}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.primary.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Total Transaction',
      field: 'totalTrans',
      render: (rowData) => (
        <Chip
          icon={<ReceiptIcon sx={{ fontSize: 16 }} />}
          label={rowData.totalTrans}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.secondary.main, 0.12),
            color: theme.palette.secondary.dark,
            border: `1.5px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.secondary.dark,
            },
          }}
        />
      ),
    },
  ];

  return (
    <ModernTable
      columns={columns}
      data={mcSale}
      title={<MyNewTitle variant="h6" />}
      options={{
        actionsColumnIndex: -1,
        pageSize: 10,
        pageSizeOptions: [10, 20, 50, 100, 200],
      }}
      actions={[
        {
          tooltip: 'Download csv',
          isFreeAction: true,
          icon: CloudDownload,
          onClick: (evt, data) => {
            msSaleTable();
          },
        },
      ]}
    />
  );
}
